import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15.96 15.303l-2.57-5.996c-.001-.001-.001-.003-.002-.004l-3.428-8a.5005.5005 0 0 0-.92 0l-3.428 8c-.001.002-.001.003-.002.005l-2.57 5.996a.5004.5004 0 1 0 .92.394l2.442-5.697H12.6l2.442 5.697a.4993.4993 0 0 0 .657.262.5012.5012 0 0 0 .263-.657h-.002zM6.83 9L9.5 2.769 12.17 9H6.83z',
  ],
  height: 20,
  width: 20,
});
